import { render, staticRenderFns } from "./ApprovalModal.vue?vue&type=template&id=ea4ef10e&scoped=true&"
import script from "./ApprovalModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4ef10e",
  null
  
)

export default component.exports